import { emitChanges } from 'src/hooks/useLocalStorage';

export const themeIAO = 'theme';
export const userThemeIAO = 'user_theme';
export const accessTokenIAO = 'access_token';
export const refreshTokenIAO = 'refresh_token';
export const isLoggedInIAO = 'is_loggedin';
export const referralCodeIAO = 'accesscode';
export const desktopAddressKey = 'desktop_address';

export function getStorageUserTheme() {
  return localStorage.getItem(userThemeIAO);
}

export function setStorageTheme(theme: string) {
  localStorage.setItem(themeIAO, theme);
  localStorage.setItem(userThemeIAO, theme);

  emitChanges(themeIAO);
  emitChanges(userThemeIAO);
}

export function getAccessToken() {
  return localStorage.getItem(accessTokenIAO);
}

export function getRefreshToken() {
  return localStorage.getItem(refreshTokenIAO);
}

export function setAuthTokens({
  accessToken,
  refreshToken,
  desktopAddress,
}: {
  accessToken: string;
  refreshToken: string;
  desktopAddress?: string;
}) {
  localStorage.setItem(accessTokenIAO, accessToken);
  localStorage.setItem(refreshTokenIAO, refreshToken);
  localStorage.setItem(isLoggedInIAO, 'true');

  if (desktopAddress) {
    localStorage.setItem(desktopAddressKey, desktopAddress);
  }

  emitChanges(accessTokenIAO);
  emitChanges(refreshTokenIAO);
}

export function removeAuthTokens() {
  localStorage.removeItem(accessTokenIAO);
  localStorage.removeItem(refreshTokenIAO);
  localStorage.removeItem(isLoggedInIAO);
  localStorage.removeItem(desktopAddressKey);

  emitChanges(accessTokenIAO);
  emitChanges(refreshTokenIAO);
}

export function clearStorage() {
  localStorage.clear();
  sessionStorage.clear();
}

export function clearCookies() {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
}

interface PersistedUserState {
  walletAddress?: string;
}

interface PersistedRootState {
  user?: string | PersistedUserState;
}

const normalizeAddress = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const getPersistedUserWalletAddress = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  try {
    const persistedRootRaw = localStorage.getItem('persist:root');
    if (!persistedRootRaw) return undefined;

    const persistedRoot = JSON.parse(persistedRootRaw) as PersistedRootState;
    const userState = persistedRoot.user;

    if (typeof userState === 'string') {
      const parsedUser = JSON.parse(userState) as PersistedUserState;
      return normalizeAddress(parsedUser.walletAddress);
    }

    if (userState && typeof userState === 'object') {
      return normalizeAddress(userState.walletAddress);
    }
  } catch {
    return undefined;
  }

  return undefined;
};

export const getCurrentUserAddressFromStorage = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  const legacyUserAddress = normalizeAddress(localStorage.getItem('userAddress'));
  const desktopAddress = normalizeAddress(localStorage.getItem(desktopAddressKey));
  const persistedUserAddress = getPersistedUserWalletAddress();

  return legacyUserAddress ?? desktopAddress ?? persistedUserAddress;
};
